<template>
  <div id="container" style="width:100%;height:100%;overflow:hidden;">
  </div>
</template>

<script>

import {mapState} from "vuex";
import {ajaxBaseUrl} from "@/config";
import {getSharedAssetsRevision} from "@/utils/sharedMiniAssets";

export default {
  computed: {
    ...mapState({
      selectInterCode: state => state.selectInterCode,
      selectTypeId: state => state.selectTypeId,
      selectInterPositionCode: state => state.selectInterPositionCode,
      carId: state => state.carId,
      carConfig: state => state.carConfig,
    }),

    useInterCode() {
      if (!this.carConfig.interTypeArr) return
      if (this.carConfig.interTypeArr[this.selectInterCode]) {
        return this.selectInterCode
      } else {
        let mapCode = this.selectInterCode
        Object.entries(this.carConfig.interTypeArr).forEach(([key, value]) => {
          if (value.mapCodeArr && value.mapCodeArr.includes(this.selectInterCode)) {
            mapCode = key
          }
        })
        return mapCode
      }
    },
    useCarId: vm => (vm.carConfig.interImgWithType ? vm.selectTypeId : vm.carId).toLowerCase().replace('400h', ''),
    panoCodeArr: vm => [vm.useCarId.toUpperCase(), vm.useInterCode, vm.selectInterPositionCode],
    panoCode: vm => vm.panoCodeArr.join('_')
  },
  watch: {
    panoCode: {
      immediate: true,
      handler() {
        // 注释掉切换时没动画。但是不容易崩溃
        // this._panoIns = null

        this.$nextTick(() => {
          if (!this._panoIns) {
            this._panoIns = new pano2vrPlayer("container")
            // window._panoIns = _panoIns
          }
          if (this.panoCode) {
            const url = `${ajaxBaseUrl}/inter/${this.carId}/${this.panoCode}/`.replace(/400h/ig,'')
            const sharedRevision = getSharedAssetsRevision()
            const panoXmlUrl = `${url}pano.xml${
              sharedRevision ? `?sharedRevision=${encodeURIComponent(sharedRevision)}` : ''
            }`
            window.fetch(panoXmlUrl, {cache: 'no-store'}).then(str => str.text()).then(panoStr => {
              panoStr = panoStr.replace(/\.\//ig, url)
              console.log('panoStr',panoStr)
              this._panoIns.readConfigString(panoStr)
              this._panoIns.startAutorotate(0.05,3,0)

              if (window.innerWidth > 750) {
                panoStr = panoStr.replace(/fov="120"/ig, 'fov="100"')
                // this._panoIns.setFov(100)
                this._panoIns.setFov(85)

                if(this.carId==='ex'){
                  if(this.selectInterPositionCode!=='copilot'){
                    this._panoIns.setProjection(9)
                  }else {
                    this._panoIns.setProjection(4)
                  }
                }
              }
            })

            //
            // this._panoIns.readConfigUrlAsync(`inter/${this.carId}/${this.panoCode}/pano.xml`,()=>{
            //   if (window.innerWidth > 980) {
            //     setTimeout(()=>{
            //       this._panoIns.setFov(80)
            //     },2000)
            //   }
            // })
          }
        })
      }
    }
  },
  methods: {},
}
</script>
<style>
.gg_contextmenu {
  display: none !important;
}

#container {
  position: absolute;
  top: 0;
  left: 0;
}
</style>
